import { useCallback, useEffect, useState } from 'react';
import Fuse from 'fuse.js';
import { useSettings } from '@backpackjs/storefront';

export function useSearchProductResults({ term, mounted = true }) {
  const settings = useSettings();

  const [productsFuse, setProductsFuse] = useState(null);
  const [productResults, setProductResults] = useState(null);
  const { productsEnabled } = { ...settings?.search?.results };

  const setProductsFuseOnMount = useCallback(async () => {
    try {
      if (productsFuse) return;
      const response = await fetch('/json/products-list.json');
      const list = await response.json();
      setProductsFuse(
        new Fuse(
          list.filter((i) => i.status === 'ACTIVE'),
          {
            keys: [{ name: 'title', weight: 2 }, 'productType'],
            ignoreLocation: true,
            minMatchCharLength: 3,
            threshold: 0.3,
          }
        )
      );
    } catch (error) {
      console.error(error.message);
    }
  }, [productsFuse]);

  const searchProductsOnTermChange = useCallback(() => {
    if (!productsFuse) return;
    if (!term) {
      setProductResults([]);
      return;
    }
    const results = productsFuse.search(term);
    setProductResults(results);
  }, [productsFuse, term]);

  useEffect(() => {
    if (!mounted || !productsEnabled) return;
    setProductsFuseOnMount();
  }, [mounted, productsEnabled]);

  useEffect(() => {
    searchProductsOnTermChange();
  }, [term, productsFuse]);

  return { productResults };
}
